import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Wand2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import StoryCard from "@/components/StoryCard";
import { Loader } from "@/components/ProtectedRoute";

const CATS = ["Toutes", "Animaux", "Magie & Féerie", "Nature", "Aventure", "Mes créations"];
const AGES = [["all", "Tous âges"], ["3-5", "3 – 5 ans"], ["6-8", "6 – 8 ans"]];

export default function Library() {
  const { user } = useAuth();
  const [stories, setStories] = useState(null);
  const [cat, setCat] = useState("Toutes");
  const [age, setAge] = useState("all");

  useEffect(() => { api.get("/stories").then((r) => setStories(r.data)); }, []);

  const shown = useMemo(() => (stories || []).filter((s) =>
    (cat === "Toutes" || s.category === cat) && (age === "all" || s.age_group === age)), [stories, cat, age]);

  return (
    <main data-testid="library-page" className="mx-auto max-w-7xl px-4 pb-24 pt-10 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="rise">
          <p className="font-bold text-[color:var(--sage)]">Bonjour {user.child_name} !</p>
          <h1 className="font-display text-4xl font-bold sm:text-5xl">La Bibliothèque</h1>
        </div>
        <Link to="/creer" data-testid="library-create-button" className="btn-primary"><Wand2 size={20} /> Créer une histoire</Link>
      </div>

      <div className="mt-8 flex flex-wrap gap-2">
        {CATS.map((c) => (
          <button key={c} data-testid={`filter-category-${c}`} onClick={() => setCat(c)} className={`chip ${cat === c ? "chip-active" : ""}`}>{c}</button>
        ))}
        <span className="mx-2 hidden w-px bg-[color:var(--line)] sm:block" />
        {AGES.map(([v, l]) => (
          <button key={v} data-testid={`filter-age-${v}`} onClick={() => setAge(v)} className={`chip ${age === v ? "chip-active" : ""}`}>{l}</button>
        ))}
      </div>

      {!stories ? <Loader /> : shown.length === 0 ? (
        <div data-testid="library-empty" className="card-paper mt-10 p-10 text-center">
          <p className="font-display text-2xl">Aucune histoire ici pour l'instant.</p>
          <Link to="/creer" className="btn-primary mt-6">Inventer la première</Link>
        </div>
      ) : (
        <div className="mt-10 grid auto-rows-auto gap-6 md:grid-cols-12">
          {shown.map((s, i) => <StoryCard key={s.id} story={s} index={i} big={i === 0 && cat === "Toutes" && age === "all"} />)}
        </div>
      )}
    </main>
  );
}
